/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Dropdown } from "antd";
import { arrayOf, bool, func, number, oneOfType, shape, string } from "prop-types";
import "./dropDown.scss";
import { TriangleTop } from "Shared/icons/triangle-top";
import { TriangleDown } from "Shared/icons";
import { hotDataLoad } from "Shared/helpers";

export const DropdownCustom = ({
	selectedKey = "",
	items = [],
	getData,
	placeholder = "",
	onSelect,
	selectedLabel,
}) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<Dropdown
			menu={{
				items,
				selectable: true,
				onSelect: onSelect,
				defaultSelectedKeys: [typeof selectedKey === "string" ? selectedKey : selectedKey.toString()],
				onScroll: (e) => hotDataLoad(e, getData),
			}}
			// arrow={true}
			trigger={["click"]}
			onOpenChange={setIsOpen}
		>
			<div>
				{selectedLabel ? selectedLabel : placeholder}
				{isOpen ? <TriangleTop /> : <TriangleDown />}
			</div>
		</Dropdown>
	);
};

DropdownCustom.propTypes = {
	selectedKey: oneOfType([string, number]),
	items: arrayOf(
		shape({
			key: oneOfType([string, number]),
			label: string,
		}),
	),
	getData: func,
	placeholder: string,
	onSelect: func,
	selectedLabel: oneOfType([string, bool]),
};
